import type { MenuConfig } from '~typings/menu'

import permisosContabilidadPg, { RESOURCE_CONTABILIDAD_PG } from '@/auth/permissions/modules/contabilidadPg'
import * as names from '@routes/contabilidad-pg/nombres/mantenimiento'

const { mantenimiento } = permisosContabilidadPg
export default [
    {
        title: 'contabilidad.configuracion.entidades_organizacionales.menu_title',
        route: names.ROUTE_ENTIDADES_ORGANIZACIONALES,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: mantenimiento.entidadesOrganizacionales,
    },

    {
        title: 'contabilidad.configuracion.clase_cuenta.menu_title',
        route: names.ROUTE_MAESTRO_CLASE_CUENTA,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: mantenimiento.maestroClaseCuenta,
    },
    // {
    //     title: 'contabilidad.configuracion.cuentas_contables.estado_plan_cuenta',
    //     route: names.ROUTE_ESTADO_PLAN_CUENTA,
    //     resource: RESOURCE_CONTABILIDAD_PG,
    //     action: mantenimiento.estadoPlanCuenta,
    // },
    {
        title: 'contabilidad.mantenimiento.plan_de_cuentas.menu_title',
        route: names.ROUTE_PLAN_DE_CUENTAS,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: mantenimiento.estadoPlanCuenta,
    },
    {
        title: 'contabilidad.configuracion.gestion_cc_sc.menu_title',
        route: names.ROUTE_GESTION_CC_SS,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: mantenimiento.gestionCcSc,
    },
    {
        title: 'contabilidad.configuracion.gestion_modulo_proceso_subproceso.menu_title',
        route: names.ROUTE_GESTION_MODULO_PROCESO_SUBPROCESO,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: mantenimiento.gestionModuloProcesoSubproceso,
    },
] as MenuConfig[]
